import { HTTPClient } from "./Client";

const AlunoApi = {

    async EditarAlunoAsync(alunoId, nomeCompleto, nomeContato, cpf, rg, dataDeNascimento, status) {
        const aluno = {
            nomeCompleto: nomeCompleto,
            nomeContato: nomeContato,
            cpf: cpf,
            rg: rg,
            dataDeNascimento: dataDeNascimento,
            status: Number(status)
        }
  
        const response = await HTTPClient.put(`/Aluno/AtualizarAluno/${alunoId}`, aluno);
       
        return response.data;
    },

    async CriarAlunoAsync(nomeCompleto, nomeContato, cpf, rg, dataDeNascimento, email, senha, confirmarSenha) {
        const alunoCriar = {
            NomeCompleto: nomeCompleto,
            NomeContato: nomeContato,
            Cpf: cpf,
            Rg: rg,
            DataDeNascimento: dataDeNascimento,
            Email: email,
            Senha: senha,
            ConfirmarSenha: confirmarSenha
        }

        await HTTPClient.post(`/Aluno/AdicionarAluno`, alunoCriar);
    },

    async ListarAlunosAsync(pagina, nome, email) {
        const alunosComPaginacao = {
            Pagina: pagina,
            Nome: nome,
            Email: email
        };


        const response = await HTTPClient.post(`/Aluno/ListarAlunos`, alunosComPaginacao);
        return response.data;
    },

    async ObterAlunoPorPessoaId(alunoId) {
        const response = await HTTPClient.get(`/Aluno/ObterAlunoPorId/${alunoId}`);
        return response.data;
    },

    async ListarStatusAlunosAsync() {
        const response = await HTTPClient.get(`/Usuario/ListarStatusUsuario`);
        return response.data;
    },
    async DeletarAlunoAsync(alunoId) {
        await HTTPClient.put(`/Aluno/DeletarAluno/${alunoId}`);
    },

    async RestaurarAlunoAsync(alunoId) {
        await HTTPClient.put(`/Aluno/RestaurarAluno/${alunoId}`);
    },
}

export default AlunoApi;